"use client"

import Image from "next/image"
import { Suspense, useMemo, useEffect } from "react";
import { PaymentTabs } from "@/components/payment/PaymentTabs";
import { TabsContent } from "@/components/ui/tabs";
import { PaymentRecharge } from "../../payment/PricingPaymentRecharge";
import { PaymentUpgrade } from "../../payment/PricingPaymentUpgrade";
import { usePaymentParams } from "@/hooks/usePaymentParams";
import { useGlobalConfig } from "@/stores/appStore";
import Loading from "@/components/Loading";
import { PaymentType } from "@/stores/slices/commonSlice";

function PricingContent() {
  usePaymentParams();
  const { value: globalConfig, fetch: fetchGlobalConfig } = useGlobalConfig().globalConfig;

  // 调用 fetch 获取配置，fetch 内部已有保护逻辑（已存在或正在加载会直接返回）
  useEffect(() => {
    fetchGlobalConfig?.();
  }, [fetchGlobalConfig]);

  // 从远程配置获取 paymentTabs，默认为空数组
  const paymentTabs = useMemo(() => {
    return globalConfig?.paymentTabs || [];
  }, [globalConfig]);

  // 根据 paymentTabs 配置渲染对应的内容
  const renderTabContent = (value: PaymentType) => {
    switch (value) {
      case 'upgrade':
        return <PaymentUpgrade />;
      case 'recharge':
        return <PaymentRecharge />;
      default:
        return null;
    }
  };

  return (
    <div
      className="flex flex-1 relative flex-col"
    >
      <Image className="absolute min-w-[1440px] self-center pointer-events-none" alt="" src="https://oss.findinai.cn/images/landing-pricing-bg.png" width={2100} height={520} />
      <div className="container">
        <div className="pt-14">
          <PaymentTabs className="bg-[#E3EBFF] box-border border boder-[#ABC5F2]/40">
            {paymentTabs.map((tab) => (
              <TabsContent key={tab.value} value={tab.value} className="mt-0">
                {renderTabContent(tab.value)}
              </TabsContent>
            ))}
          </PaymentTabs>
        </div>
      </div>
    </div >
  )
}

export function Pricing() {
  return (
    <Suspense fallback={<Loading mask />}>
      <PricingContent />
    </Suspense>
  );
}

